module.exports = __webpack_public_path__ + "img/Ups.2ba7bf28.png";